import React, { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
const buyers = [{
  name: 'Carlos',
  city: 'Madrid'
}, {
  name: 'Javier',
  city: 'Valencia'
}, {
  name: 'David',
  city: 'Sevilla'
}, {
  name: 'Alejandro',
  city: 'Barcelona'
}, {
  name: 'Miguel',
  city: 'Bilbao'
}, {
  name: 'Pablo',
  city: 'Zaragoza'
}, {
  name: 'Sergio',
  city: 'Málaga'
}, {
  name: 'Raúl',
  city: 'Alicante'
}];
export function SalesPopup() {
  const [visible, setVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring
    const interval = setInterval(() => {
      showPopup();
    }, 25000); // Every 25 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto flex max-w-sm items-center gap-3 rounded-lg border-l-4 border-green-500 bg-white p-3 shadow-2xl animate-in slide-in-from-bottom-5 fade-in duration-500 md:left-auto md:right-4 md:mx-0 md:w-80" data-id="element-197" data-mp="29p0nqx26pvna">
      <div className="flex-shrink-0 rounded-full bg-green-100 p-2" data-id="element-198" data-mp="2ngxccr4n9nex">
        <MapPin className="h-5 w-5 text-green-600" data-id="element-199" data-mp="2nja39tsdr844" />
      </div>
      <div className="min-w-0" data-id="element-200" data-mp="2shbmqftpx9g4">
        <p className="text-xs text-gray-500" data-id="element-201" data-mp="2se79yu26t5du">Alguien acaba de comprar</p>
        <p className="text-sm font-bold text-gray-900" data-id="element-202" data-mp="2xe22f21m2310">
          {currentBuyer.name} de {currentBuyer.city}, España
        </p>
        <p className="text-xs text-green-600 font-semibold" data-id="element-203" data-mp="y4c1o76kjn1g">
          Hace unos minutos
        </p>
      </div>
    </div>;
}